import { Pipe, PipeTransform } from '@angular/core';
import { MapItem } from '@capturum/ui/api';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Observable, of as observableOf } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'formlySelectOptions',
  standalone: true,
})
export class FormlySelectOptionsPipe implements PipeTransform {
  public transform(options, field?: FormlyFieldConfig): Observable<MapItem[]> {
    let options$ = options;

    if (!(options instanceof Observable)) {
      options$ = observableOf(options);
    }

    return options$.pipe(
      map((value) => {
        return this.toOptions(value, field || {});
      }),
    );
  }

  private toOptions(options, field: FormlyFieldConfig): MapItem[] {
    const gOptions: any[] = [],
      groups: { [key: string]: any[] } = {},
      to = field.props || {};

    options.map((option: any) => {
      if (!this.getGroupProp(option, to)) {
        gOptions.push(this.toOption(option, to));
      } else {
        if (!groups[this.getGroupProp(option, to)]) {
          groups[this.getGroupProp(option, to)] = [];
          gOptions.push({
            label: this.getGroupProp(option, to),
            group: groups[this.getGroupProp(option, to)],
          });
        }
        groups[this.getGroupProp(option, to)].push(this.toOption(option, to));
      }
    });

    return gOptions;
  }

  private toOption(item, to): MapItem & { disabled: boolean | string } {
    return {
      label: this.getLabelProp(item, to),
      value: this.getValueProp(item, to),
      disabled: this.getDisabledProp(item, to) || false,
    };
  }

  private getLabelProp(item, to): string {
    if (typeof to.labelProp === 'function') {
      return to.labelProp(item);
    }

    if (this.shouldUseLegacyOption(item, to)) {
      return item.value;
    }

    return item[to.labelProp || 'label'];
  }

  private getValueProp(item, to): string {
    if (typeof to.valueProp === 'function') {
      return to.valueProp(item);
    }

    if (this.shouldUseLegacyOption(item, to)) {
      return item.key;
    }

    return item[to.valueProp || 'value'];
  }

  private getDisabledProp(item, to): string {
    if (typeof to.disabledProp === 'function') {
      return to.disabledProp(item);
    }

    return item[to.disabledProp || 'disabled'];
  }

  private getGroupProp(item, to): string {
    if (typeof to.groupProp === 'function') {
      return to.groupProp(item);
    }

    return item[to.groupProp || 'group'];
  }

  private shouldUseLegacyOption(item, to): boolean {
    return (
      !to.valueProp && !to.labelProp && item != null && typeof item === 'object' && 'key' in item && 'value' in item
    );
  }
}
